import React, { useState,useEffect } from 'react'
import { useEditProductMutation, useListByIdQuery } from '../../../api/product.api'
import { toast,ToastContainer } from 'react-toastify'
import AdminTitle from '../../../common/AdminTitle/AdminTitle'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import ProductForm from './ProductForm';

const ProductEdit = () => {
  const params = useParams()
  const [product, setProduct] = useState()
  const [loading, setLoading] = useState()
  const navigate = useNavigate()

  const {data:products, isLoading} = useListByIdQuery(params.id)
  const [editProduct] = useEditProductMutation()

    useEffect(()=>{
      if(products){
        setProduct(products.result)
      }
    },[products])

  const submitEvent = async(data)=>{
    setLoading(true)
    try{
       const formData = new FormData();          
        // Required fields
        formData.append("title", data.title);
        formData.append("price", data.price);
        formData.append("cost", data.cost);
        formData.append("description", data.description || null);
        formData.append("fit", data.fit || null);
        formData.append("modelSize", data.modelSize || null);
        formData.append("materialCare", data.materialCare || null);

        // Handle nested fields safely
        if (data.wearable?.value) {
            formData.append("wearable", data.wearable.value); // Send `value` only if it exists
        }
            
        if (data.sizes && data.sizes.length > 0) {
            data.sizes.forEach((size, index) => {
                formData.append(`sizes[${index}][size]`, size.size);
                formData.append(`sizes[${index}][quantity]`, size.quantity);
            });
        }

        if (data.productCollections && data.productCollections.length > 0) {
            data.productCollections.forEach((collection) => {
                formData.append("productCollections[]", collection.value); // Send collection IDs
            });
        }

        // Always send media order information, even if no new files
        if (data.media && data.media.length > 0) {
            // Send media order information
            const mediaOrder = data.media.map((mediaItem, index) => {
                if (typeof mediaItem === 'object' && mediaItem._id) {
                    return mediaItem._id;
                } else if (typeof mediaItem === 'object' && mediaItem.url) {
                    return mediaItem.url;
                } else if (typeof mediaItem === 'string') {
                    return mediaItem; // For legacy string URLs
                }
                return `new-${index}`;
            });
            formData.append("mediaOrder", JSON.stringify(mediaOrder));
            
            // Only append new files, not existing URLs
            data.media.forEach((mediaItem) => {
                if (mediaItem instanceof File) {
                    formData.append("media", mediaItem);
                }
            });
        } else {
            // Even if no media, send empty array to clear existing media
            formData.append("mediaOrder", JSON.stringify([]));
        }
       
        await editProduct({id:params.id,  payload:formData}).unwrap();          
        toast.success("Product updated successfully");
        navigate('/dashboard/product')
    }catch(exception){
      toast.error('Error While Updating Product')
    }finally{
      setLoading(false)
    }
  }

  return (
    <div className='admin_margin_box'>
      <ToastContainer />
      <div className="admin_titles">
        <AdminTitle label1=" Product List" label2="/Edit Product" url="/dashboard/product" />
        <div className='Dashboard_title'>
          <h1>Edit Product</h1>
        </div>
      </div>

      <div className="banner_form">
        <ProductForm detail={
            {
                title:product?.title,
                materialCare:product?.materialCare,
                fit:product?.fit,
                modelSize:product?.modelSize,
                description:product?.description,
                price:product?.price,
                cost:product?.cost,
                media:product?.media || [],
                // Backward compatibility - convert old format to new
                video:product?.video,
                images:product?.images || [],
                wearable: {
                  label: product?.wearable === 'Summer' && 'Summer' ||  product?.wearable === 'Winter' && 'Winter' ||  product?.wearable === 'Both' && 'Summer and Winter',
                  value: product?.wearable
                },
                sizes: product?.sizes || [], // Pass sizes directly
                productCollections: product?.productCollections?.map((col) => ({
                  label: col.name,
                  value: col._id,
                })) || [],
            }
        } 
        submitEvent={submitEvent}
        loading={loading}
        value='Update product'
        />
      </div>
    </div>
  )
}

export default ProductEdit